// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1gIeG","label":"Labeled_label__2VnQr","divider":"Labeled_divider__3GZ7f"};